<template>
    <div>
        <slot name="submit-button" :submit="submit"></slot>
    </div>
</template>

<script>
    export default {
        name: 'dropzone-submit',
        props: ['delete_route', 'csrf'],
        data() {
            return {
                submitted: false,
            }
        },
        methods: {
            submit() {
                jQuery('#add_task_form').submit(function(e) {
                    jQuery(':disabled').each(function(e) {
                        $(this).removeAttr('disabled');
                    });
                    jQuery('#submitBtn').attr('disabled', true);
                });
                document.cookie = "tabID = " + sessionStorage.getItem('tabID') + "; path=/;";
                this.submitted = true;
            },
            unload() {
                var IE = window.navigator.userAgent.indexOf("MSIE") > 0;
                if (!this.submitted && !IE) {
                    document.cookie = "tabID = " + sessionStorage.getItem('tabID') + "; path=/;";
                    let data = new FormData();
                    data.append('_token', this.csrf);
                    navigator.sendBeacon(this.delete_route, data);
                }
            },
        },
        created() {
            window.addEventListener('unload', this.unload);
        }
    }
</script>
